var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriuosFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3208 28.152C22.843 28.152 28.1303 22.8647 28.1303 16.3425C28.1303 9.82026 22.843 4.53296 16.3208 4.53296C9.79853 4.53296 4.51123 9.82026 4.51123 16.3425C4.51123 22.8647 9.79853 28.152 16.3208 28.152Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6305 14.1282C13.4458 14.1282 14.1067 13.4673 14.1067 12.652C14.1067 11.8368 13.4458 11.1758 12.6305 11.1758C11.8152 11.1758 11.1543 11.8368 11.1543 12.652C11.1543 13.4673 11.8152 14.1282 12.6305 14.1282Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0113 14.1282C20.8266 14.1282 21.4875 13.4673 21.4875 12.652C21.4875 11.8368 20.8266 11.1758 20.0113 11.1758C19.1961 11.1758 18.5352 11.8368 18.5352 12.652C18.5352 13.4673 19.1961 14.1282 20.0113 14.1282Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8921 19.2949H20.7492",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriuosFace);
export default __webpack_public_path__ + "static/media/seriuos-face.b3d19906e173cf57f8cef8171f9229e6.svg";
export { ForwardRef as ReactComponent };